import Component from '../abstracts/Component';
// quick refactoring of privacyComponent
export default class PrivacyPreference extends Component {

  initFormPreference() {
	  let ctx = this;

	  ctx.showSelect(ctx);
	  ctx.methodDefault(ctx);
	  
	  $('body').on('click.fu', '#contact-preference-warning-modal a', function(e) {

		  var ctaLink = $('#updateContactPreferenceForm').find('.cta--link').attr('href');

		  $('#contact-preference-warning-modal').find('.cta--link').attr('href', ctaLink);

	  });

	  $('body').on('click.fu', '.js-apply-contact-preference-options', function(e) {
	      e.preventDefault();

	      $('.js-apply-contact-preference-options').prop('disabled', true);
	      $('#updateContactPreferenceForm').submit();
	      return true;

	  });

  }

  showSelect(ctx) {

	  this.$on('change', ({event}) => {

		  ctx.populateSelect();

	  });
  }

  populateSelect() {
	  $.each($('#updateContactPreferenceForm .row-country-language .form-group'), function() {

		  var _this = $(this);

		  _this.find('select').attr('value', _this.find('select')[0].value);
      });
  }

  optionNewsletter() {

	    let ctx = this;

	    $('#updateContactPreferenceForm .privacy-preference .profiling input').click(function (e) {
	    	ctx.checkNewsletter($(this));
	    });	  
  }

  methodDefault($ctx) {

	  var newsletter = $('.profiling').find('.first-condition input')[0];
	  var sms = $('.profiling').find('.second-condition input')[0];
  	  var email = $('.profiling').find('.second-condition input')[1];
  	  var thirdCondition = $('.profiling').find('.third-condition input');

	  if(newsletter.value == 'true' && thirdCondition[0].value == ''){	  
	  	  sms.checked = true;
	  	  email.checked = true;

	  	  thirdCondition.attr('value', sms.value + ";" + email.value);
	  }
	  else if
	    (newsletter.value == 'false' && thirdCondition[0].value == '') {
		  sms.checked = false;
	 	  email.checked = false;

	 	  thirdCondition.attr('value', '');
	  }
	  else if
	    ((newsletter.value == 'true' || newsletter.value == 'false') && thirdCondition[0].value == 'SMS') {
	  	  sms.checked = true;
	  	  email.checked = false;

	  	  thirdCondition.attr('value');
	  }
	  else if
	    ((newsletter.value == 'true' || newsletter.value == 'false') && thirdCondition[0].value == 'E-mail') {
	  	  sms.checked = false;
	  	  email.checked = true;

	  	  thirdCondition.attr('value');
	  }
	  else if
	    ((newsletter.value == 'true' || newsletter.value == 'false') && (thirdCondition[0].value == 'SMS;E-mail') || thirdCondition[0].value == 'E-mail;SMS') {
	  	  sms.checked = true;
	  	  email.checked = true;

	  	  thirdCondition.attr('value');
	  }
	  $ctx.showModal($(this));

  }

  checkNewsletter($this) {
	  let ctx = this;

	  var newsletter = $('.profiling').find('.first-condition input')[0];
	  var sms = $this.closest('.second-condition').find('input')[0];
  	  var email = $this.closest('.second-condition').find('input')[1];
  	  var thirdCondition = $('.profiling').find('.third-condition input');

  	  if(sms.checked == true && email.checked == false) {  		  

  		  thirdCondition.attr('value', sms.value); 
  	  }
  	  else if 
		((newsletter.value == 'true' || newsletter.value == 'false') && sms.checked == false && email.checked == true) {
	  		thirdCondition.attr('value', email.value);
  	  }
  	  else if 
		((newsletter.value == 'true' || newsletter.value == 'false') && sms.checked == true && email.checked == true) {
	  		thirdCondition.attr('value', sms.value + ";" + email.value);
  	  }
  	  else if 
		(newsletter.value == 'true' && sms.checked == false && email.checked == false && $this[0].value == sms.value) {
  			thirdCondition.attr('value', sms.value);
  	  }
  	  else if 
		(newsletter.value == 'true' && sms.checked == false && email.checked == false && $this[0].value == email.value) {
			thirdCondition.attr('value', email.value);
  	  }
  	  else {
  		  thirdCondition.attr('value', '');
  	  }
  	  ctx.showModal($this);
  }

  showModal($this) {

	  var newsletter = $('.profiling').find('.first-condition input')[0];
	  var sms = $('.profiling').find('.second-condition #preferenceContactSms');
  	  var email = $('.profiling').find('.second-condition #preferenceContactEmail');

  	  if (newsletter.value == 'true') {

  		  if(sms[0].checked == true && email[0].checked == false) {
				sms.attr('data-modal', 'true');
				sms.attr('href', '/action/ajax/contact-preference-warning');
  		  }
  		  else if 
			(sms[0].checked == false && email[0].checked == true) {
				email.attr('data-modal', 'true');
				email.attr('href', '/action/ajax/contact-preference-warning');
  		  }
  		  else if 
			(sms[0].checked == true && email[0].checked == true) {
				sms.removeAttr('data-modal');
				sms.removeAttr('href');

				email.removeAttr('data-modal');
				email.removeAttr('href');
  		  }
  	  }
  }


  render() {
	  if(($('body').data('template') === 't-contact-preference') &&
		  $('body').find('#contact-preferences').hasClass('privacy-update')) {
		  	this.initFormPreference();
			this.optionNewsletter();
	  }
  }
}